import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  useEffect(()=>{ api.get("/blogs").then(r=>setBlogs(r.data)); }, []);
  const posts = blogs.length ? blogs : [
    { id:"1", title:"How to choose the perfect wedding lawn", excerpt:"Space, ambience, monsoon backup — what to check before you book.", cover_image:"https://images.pexels.com/photos/37331160/pexels-photo-37331160.jpeg?auto=compress&cs=tinysrgb&h=650&w=940", slug:"choose-perfect-lawn" },
    { id:"2", title:"Ten catering must-haves for 500+ guests", excerpt:"From live counters to service ratios, our checklist for grand weddings.", cover_image:"https://images.pexels.com/photos/36766881/pexels-photo-36766881.jpeg?auto=compress&cs=tinysrgb&h=650&w=940", slug:"catering-checklist" },
    { id:"3", title:"Decor trends for 2026 Indian weddings", excerpt:"Moody florals, phulkari drapes, minimalist mandaps and more.", cover_image:"https://images.pexels.com/photos/12688995/pexels-photo-12688995.jpeg?auto=compress&cs=tinysrgb&h=650&w=940", slug:"decor-trends-2026" },
  ];
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
      <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--wine)]">Journal</div>
      <h1 className="font-display text-5xl mb-10">Stories, checklists & inspiration</h1>
      <div className="grid md:grid-cols-3 gap-8">
        {posts.map(p=>(
          <article key={p.id} className="card-luxury overflow-hidden">
            <img src={p.cover_image} className="aspect-[16/10] w-full object-cover" alt={p.title}/>
            <div className="p-6">
              <h3 className="font-display text-2xl leading-tight">{p.title}</h3>
              <p className="text-sm text-neutral-600 mt-2">{p.excerpt}</p>
              <div className="mt-4 text-[color:var(--wine)] text-sm">Read more →</div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
